import React from 'react';
import { Link } from 'react-router-dom';

import './../styles/TestSelection.css';

const TestSelection = () => {
  return (
    <div className="test-selection">
      <h1>Chọn chế độ thi</h1>
      <div className="test-options">
        <div className="test-option-card">
          <h2>Luyện từng kỹ năng</h2>
          <p>Tập trung vào một kỹ năng bạn muốn cải thiện.</p>
          <button className="btn btn-secondary" disabled>Sắp có</button>
        </div>
        <div className="test-option-card">
            <h2>Flyers Reading & Writing Part 1</h2>
            <p>Luyện tập kỹ năng đọc và nối từ vựng theo định nghĩa.</p>
            <Link to="/test/exam_flyers_test_01_part_1" className="btn btn-primary">
              Bắt đầu
            </Link>
        </div>
        <div className="test-option-card">
            <h2>Flyers Reading & Writing Part 2</h2>
            <p>Luyện tập kỹ năng đọc hiểu và chọn câu trả lời cho hội thoại.</p>
            <Link to="/test/exam_flyers_test_01_part_2_conversation" className="btn btn-primary">
              Bắt đầu
            </Link>
        </div>
        <div className="test-option-card">
            <h2>Flyers Reading & Writing Part 3</h2>
            <p>Luyện tập điền từ vào chỗ trống và chọn tiêu đề cho câu chuyện.</p>
            <Link to="/test/flyers_test_william_dog" className="btn btn-primary">
              Bắt đầu
            </Link>
        </div>
        <div className="test-option-card">
            <h2>Flyers Reading & Writing Part 4</h2>
            <p>Luyện tập đọc hiểu và chọn từ đúng cho chỗ trống.</p>
            <Link to="/test/flyers_test_octopuses" className="btn btn-primary">
              Bắt đầu
            </Link>
        </div>
        <div className="test-option-card">
            <h2>Flyers Reading & Writing Part 5</h2>
            <p>Đọc câu chuyện và hoàn thành các câu bên dưới.</p>
            <Link to="/test/flyers_test_the_concert" className="btn btn-primary">
              Bắt đầu
            </Link>
        </div>
        <div className="test-option-card">
            <h2>Flyers Reading & Writing Part 6</h2>
            <p>Đọc bưu thiếp và điền từ còn thiếu vào chỗ trống.</p>
            <Link to="/test/flyers_test_camping_postcard" className="btn btn-primary">
              Bắt đầu
            </Link>
        </div>
        <div className="test-option-card">
            <h2>Flyers Reading & Writing Part 7</h2>
            <p>Viết một câu chuyện ngắn dựa trên các bức tranh.</p>
            <Link to="/test/flyers_test_desert_camel_story" className="btn btn-primary">
              Bắt đầu
            </Link>
        </div>
        
      </div>
    </div>
  );
};

export default TestSelection;
